import { createTheme } from '@mui/material/styles'

const fontTheme = createTheme({
  typography: {
    fontFamily: ['"Montserrat"', 'Open Sans'].join(','),
  },
})

export default fontTheme
